import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import MakeAsyncFunction from 'react-redux-promise-listener';
// import validations from './validations';
import InputField from 'src/components/InputField';
// import SelectField from 'src/components/SelectField';
import { promiseListener } from 'src/store';
import {useState , useEffect} from 'react';


const FormBody = ({ handleSubmit, }) => {
    const [disabled , setDisabled] = useState(true)
    const handleClick = () => {
        setDisabled(!disabled)
    };

    const normalizePhone = value =>{
        if (!value) return value;
        const onlyNums = value.replace(/[^\d]/g, "");
        return onlyNums.slice(0, 11)
    }

    const emailValidator = value => {
        const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        if (re.test(value)) {
            return undefined
        } else {
            return 'Email inválido'
        }
    }

    const required = value => (value ? undefined : 'Este campo é obrigatório')

    return (
    <form onSubmit={handleSubmit}> 
        <fieldset disabled={disabled}>                     
        <div className="pl-lg-4">
            <div className="row">
                <div className="col-12 col-md-6">
                    <Field
                        name="name"
                        type="text"
                        className="form-control"
                        label="Nome"
                        validate={required}
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <Field
                        name="email"
                        type="email"
                        className="form-control"
                        label="Email"
                        validate={required, emailValidator}
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <Field
                        name="phone"
                        type="number"
                        className="form-control"
                        label="Telefone"
                        validate={required}
                        parse={normalizePhone}
                        component={InputField}
                    />
                </div>
            </div>
        </div>
        </fieldset>
        <div className="text-center">
            <button type="submit" className="btn btn-success mt-4">Salvar</button>
            <button type="button" className="btn btn-success mt-4" onClick={handleClick}>Editar dados</button>
        </div>
    </form>
)};

const UserForm = (props) => {
    const [user , setUser] = useState('')

    useEffect(() => {
        props = props['props']
        if (props['portalUser']) {
            setUser(props['portalUser']['user'])
        }
    }, [props])

    return (
    <MakeAsyncFunction
        listener={promiseListener}
        start="UPDATE_ACCOUNT_SUBMIT"
        resolve="UPDATE_ACCOUNT_SUCCEEDED"
        reject="UPDATE_ACCOUNT_FAILED"
        >{submit => (
            <Form
                onSubmit={submit}
                initialValues={user}
                render={(user) => ( <FormBody {...user}/>)}
            />
        )}
    </MakeAsyncFunction>
)};

export default UserForm;


// WEBPACK FOOTER //
// ./src/components/Pages/Account/Form.js